export const GOOGLE_PLACES_SESSION_KEY = "google_places_session";
export const MARKER_URL = "/app/themes/adaptable/assets/dist/images/marker.svg";
export const COMING_SOON_MARKER_URL = "/app/themes/adaptable/assets/dist/images/coming-soon-marker.svg";
export const SELECTED_MARKER_URL =
    "/app/themes/adaptable/assets/dist/images/selected-marker.svg";
export const CIRCLE_CENTRE_MARKER =
    "/app/themes/adaptable/assets/dist/images/circle-centre-marker.svg";
